export default "__VITE_ASSET__CkAwlHgT__"